import React, { useEffect, useState } from 'react';
import {
  Box,
  CircularProgress,
  Divider,
  Grid, LinearProgress, Tab, Tabs,
} from '@mui/material';
import { useNavigate } from 'react-router-dom';
import Zoom from 'react-medium-image-zoom';
import 'react-medium-image-zoom/dist/styles.css';
import { useDispatch } from 'react-redux';
import { ChevronRightRounded } from '@mui/icons-material';
import moment from 'moment';
import Elements from '../../../Elements';
// import Images from '../../../../Configs/images';
import { getDigitalBox, getDigitalBoxDetails } from '../../../../Redux/Models/box';
import Images from '../../../../Configs/images';
import ROUTES from '../../../../Configs/routes';
import { formatNumToCurrency, formatVolumeToInt } from '../../../../Utils/helpers';

export default function Home({
  classes, data, selected, isLoading, isLoadingDetails,
}) {
  const navigate = useNavigate();
  const dispatch = useDispatch();

  const [selectedBox, setSelectedBox] = useState('');

  const [activeTab, setActiveTab] = useState(1);
  const handleChangeTab = (e, newVal) => {
    setActiveTab(newVal);
  };

  useEffect(() => {
    dispatch(getDigitalBox());
  }, []);

  useEffect(() => {
    if (selectedBox) {
      dispatch(getDigitalBoxDetails(selectedBox));
    }
  }, [selectedBox]);

  const renderBoxes = () => {
    if (isLoading) {
      return (
        <LinearProgress color="inherit" className="mt-4" />
      );
    }

    if (data.length) {
      return (
        <Grid container spacing={1} sx={{ mt: 2 }} justifyContent="center">
          {data.map((e, idx) => (
            <Grid item lg={4} key={idx} sx={{ mb: 2 }}>
              <div className="center">
                <div className="s-18 weight-700">
                  Aisle
                  {' '}
                  {e.name}
                </div>
                <div className="s-14 mt-1">20 Used 80 Available 100 Totals</div>
              </div>
              <table className="mt-3">
                <thead>
                  <tr>
                    <td aria-label="empty-td" />
                    <td className="s-14 center">A</td>
                    <td className="s-14 center">B</td>
                    <td className="s-14 center">C</td>
                    <td className="s-14 center">D</td>
                    <td className="s-14 center">E</td>
                  </tr>
                </thead>
                <tbody>
                  {e.row.map((ev, i) => (
                    <tr key={i}>
                      <td className="s-14">{ev.name}</td>
                      {ev.column.map((col) => (
                        <td key={col.id} aria-label={col.id}>
                          <div
                            onClick={() => setSelectedBox(col.id)}
                            className={`storage pointer ${col.status} ${selectedBox === col.id && 'selected'}`}
                          />
                        </td>
                      ))}
                    </tr>
                  ))}
                </tbody>
              </table>
            </Grid>
          ))}
        </Grid>
      );
    }

    return null;
  };

  const renderItemInfo = () => {
    if (isLoadingDetails) {
      return (
        <div className="center mt-4">
          <CircularProgress color="inherit" />
        </div>
      );
    }
    if (selected.length) {
      const { item = {}, user = { user: {}, address: {} } } = selected[0];
      return (
        <div>
          <div className="box-info mt-3">
            <div className="flex space-between align-items-center">
              <h4>{item.name}</h4>
              <img src={Images.SafetyGuarantee} alt="safety" />
            </div>
            <div className="flex space-between align-items-center mt-2">
              <div className="mute s-12">
                {item.id}
              </div>
              {/* <div className="mute s-12">12:12 - 12/12/2022</div> */}
            </div>

            <Divider sx={{ my: 2 }} />

            <div className="flex space-between">
              <div className="fullwidth">
                <div className="mute s-12">Category</div>
                <div className="weight-500 s-14 mt-1">{item.category?.name}</div>
              </div>
              <div className="fullwidth">
                <div className="mute s-12">Condition</div>
                <div className="weight-500 s-14 mt-1">{item.condition?.name}</div>
              </div>
              <div className="fullwidth">
                <div className="mute s-12">Volume</div>
                <div className="weight-500 s-14 mt-1">
                  {item.volume}
                </div>
              </div>
            </div>
          </div>

          <div className="box-info mt-3">
            <div className="flex space-between align-items-center">
              <h4>Owner info</h4>
            </div>

            <Divider sx={{ my: 2 }} />

            <div className="flex space-between">
              <div className="fullwidth">
                <div className="mute s-12">User name</div>
                <div className="weight-700 s-14 mt-1">{user.user.username}</div>
              </div>
              <div className="fullwidth">
                <div className="mute s-12">Phone number</div>
                <div className="weight-700 s-14 mt-1">{user.user.phone_number}</div>
              </div>
            </div>

            <div className="flex space-between mt-3">
              <div className="fullwidth">
                <div className="mute s-12">User ID</div>
                <div className="weight-700 s-14 mt-1">
                  {user.user.id?.substr(0, 8)}
                  ...
                </div>
              </div>
              <div className="fullwidth">
                <div className="mute s-12">Membership</div>
                <div className="mt-1 inline-block">
                  <Box sx={{ pl: 0.5 }} className="pil flex align-items-center gap-8">
                    {user.user.subscription === 'Premium Plan'
                      ? <img height="20" width="20" src={Images.PremiumStar} alt="premium" /> : <img height="20" width="20" src={Images.NormalStar} alt="normal" />}
                    <div className="s-12 black weight-500">{user.user.subscription}</div>
                  </Box>
                </div>
              </div>
            </div>
            <div className="mt-3">
              <div className="mute s-12">Pick up address</div>
              <div className="weight-700 s-14 mt-1">
                {user.address.address}
                ,
                {' '}
                {user.address.address}
                ,
                {' '}
                {user.address.province}
                ,
                {' '}
                {user.address.country}
                ,
                {' '}
                {user.address.postal_code}
              </div>
            </div>
          </div>

          <div className="box-info mt-3">
            <div className="flex space-between align-items-center">
              <h4>Item details</h4>
            </div>

            <Divider sx={{ my: 2 }} />

            <div>
              <div className="mt-3">
                <div className="mute s-12">Item volume</div>
                <div className="weight-700 s-14 mt-1">
                  {item.volume}
                </div>
              </div>
              <div className="mt-3">
                <div className="mute s-12">Item category</div>
                <div className="weight-700 s-14 mt-1">{item.category?.name}</div>
              </div>
              <div className="mt-3">
                <div className="mute s-12">Item condition</div>
                <div className="weight-700 s-14 mt-1">
                  {item.condition?.name}
                </div>
              </div>
              <div className="mt-3">
                <div className="mute s-12">Notes</div>
                <div className="weight-700 s-14 mt-1">
                  {item.notes}
                </div>
              </div>
              <div className="mt-3">
                <div className="mute s-12">Photo</div>
                <div className="mt-1">
                  <Zoom>
                    <img className="rounded" width="80" height="80" src={item.photo} alt="item" />
                  </Zoom>
                </div>
              </div>
            </div>
          </div>
        </div>
      );
    }
    if (!selected.length && selectedBox) {
      return <NoData title="No item info for this storage" desc="Detail information about the storage will appear in here" />;
    }
    return <NoData title="Select an Storage to see information" desc="Detail information about the storage will appear in here" />;
  };

  const renderMarketInfo = () => {
    if (isLoadingDetails) {
      return (
        <div className="center mt-4">
          <CircularProgress color="inherit" />
        </div>
      );
    }
    if (selected.length) {
      return selected.map((item) => {
        const volume = formatVolumeToInt(item.volume);
        if (item.is_sale) {
          return (
            <div key={item.id}>
              <img src={item.photo} alt="market item" height="320" className="cover rounded mt-3" style={{ width: '100%' }} />
              <div className="box-info mt-3">
                <div className="flex space-between align-items-center mt-2">
                  <div className="weight-700 s-16">
                    ₣
                    {formatNumToCurrency((1000 / volume) * item.price)}
                    <span className="mute s-12 weight-400">/L</span>
                  </div>
                  <Box sx={{ pl: 0.5 }} className="pil flex align-items-center gap-4">
                    <img src={item.sale_type === 'Bid Price' ? Images.BidPrice : Images.FixedPrice} alt="price" />
                    <div className="s-12 weight-500">{item.sale_type}</div>
                  </Box>
                </div>

                <div className="mt-3 s-14">{item.name}</div>

                <Divider sx={{ my: 2 }} />

                <div>
                  <div className="mute s-12">Marketed on</div>
                  <div className="weight-700 s-14 mt-1">
                    {moment(new Date(item.marketed_on)).format('HH.mm - DD/MM/YYYY')}
                  </div>
                </div>

                <Box
                  sx={{
                    border: '1px solid #DADADA', py: 1, pl: 2, pr: 1,
                  }}
                  className="link rounded flex align-items-center space-between mt-3"
                  onClick={() => navigate(`${ROUTES.market()}/update/${item.id}`)}
                >
                  <div className="s-14">See in market</div>
                  <ChevronRightRounded />
                </Box>

              </div>

              <div className="box-info mt-3">
                <div className="flex space-between align-items-center">
                  <h4>Details information</h4>
                </div>

                <Divider sx={{ my: 2 }} />

                <div className="flex space-between">
                  <div className="fullwidth">
                    <div className="mute s-12">Category</div>
                    <div className="weight-700 s-14 mt-1">Cat</div>
                  </div>
                  <div className="fullwidth">
                    <div className="mute s-12">Condition</div>
                    <div className="weight-700 s-14 mt-1">Con</div>
                  </div>
                </div>

                <div className="flex space-between mt-3">
                  <div className="fullwidth">
                    <div className="mute s-12">Price</div>
                    <div className="weight-700 s-14 mt-1">
                      $
                      {item.price}
                    </div>
                  </div>
                  <div className="fullwidth">
                    <div className="mute s-12">Volume</div>
                    <div className="weight-700 s-14 mt-1">
                      {item.volume}
                    </div>
                  </div>
                </div>

                <div className="mt-3">
                  <div className="mute s-12">Notes</div>
                  <div className="weight-700 s-14 mt-1">
                    {item.notes}
                  </div>
                </div>
              </div>

            </div>
          );
        }
        return <NoData title="No market info for this storage" desc="Detail information about the storage will appear in here" />;
      });
    }
    if (!selected.length && selectedBox) {
      return <NoData title="No market info for this storage" desc="Detail information about the storage will appear in here" />;
    }
    return <NoData title="Select an Storage to see information" desc="Detail information about the storage will appear in here" />;
  };

  return (
    <Elements.AdminPageBase navigate={navigate} title="Storages">
      <div className={classes.root}>
        <Grid container spacing={2}>
          <Grid item md={8}>
            <div className="flex space-between">
              <div>
                <div className="flex align-items-center">
                  <div className="storage available" />
                  <div>
                    <div className="weight-700">800/1000</div>
                    <div className="s-14">available storages</div>
                  </div>
                </div>
              </div>

              <div className="flex align-self-center gap-16">
                <div className="flex align-items-center">
                  <div className="storage not_available" />
                  <div>
                    <div className="weight-700">Used storage</div>
                  </div>
                </div>
                <div className="flex align-items-center">
                  <div className="storage empty" />
                  <div>
                    <div className="weight-700">Empty storage</div>
                  </div>
                </div>
              </div>
            </div>

            <div className="mt-2">
              {renderBoxes()}
            </div>
          </Grid>

          <Grid item md={4}>
            <aside className="sticky">
              <Box sx={{ borderBottom: 1, borderColor: 'divider' }}>
                <Tabs value={activeTab} className={`${classes.tabs}`} variant="fullWidth" onChange={handleChangeTab}>
                  <Tab label="Item info" value={1} disableRipple />
                  <Tab label="Market info" value={2} disableRipple />
                </Tabs>
              </Box>

              {activeTab === 1 && renderItemInfo()}
              {activeTab === 2 && renderMarketInfo()}

            </aside>
          </Grid>
        </Grid>
      </div>
    </Elements.AdminPageBase>
  );
}

function NoData({ title, desc }) {
  return (
    <div className="center box-info mt-3">
      <img src={Images.RunOut} alt="no data" />
      <h4 className="mt-3">{title}</h4>
      <div className="mt-3">{desc}</div>
    </div>
  );
}
